
import Vue from 'vue'
import { SchoolTeacherDto } from '@ViewModels/SchoolTeacherDto'
import * as Api from '@/api/SchoolSettingsApi'
import { DataSet, ODataService } from '@/services'
import { RouteButton } from '@/components/buttons'
import { PageHeader } from '../components'
import { PagedDataTable, FilterDropdown, FilterText, FilterToggle } from '@/components/lists'

export default Vue.extend({
   name: 'TeacherList',
   props: {
      schoolId: { type: String, default: '' },
   },
   data() {
      return {
         dataset: new DataSet(new ODataService('SchoolTeacher')),
         classroomOptions: [] as NameValuePair[],
         crumbs: [{ text: 'Teachers' }] as Breadcrumb[],
         columns: [
            { name: 'Name', title: 'Name', sortColumn: 'FirstName' },
            { name: 'ClassRoomNames', title: 'Classes', type: 'list', sortable: false },
            {
               name: 'SchoolTeacherGroupNames',
               title: 'Collaborative Teacher Groups',
               type: 'list',
               sortable: false,
            },
            { name: 'IsAdminForSchool', title: 'Admin', type: 'boolean' },
            { name: 'PrivatePlanning', title: 'Private', type: 'boolean' },
            { name: 'IsEnabled', title: 'Active', type: 'boolean-hide' },
         ] as IDataTableColumn[],
      }
   },
   computed: {
      activeSchoolId(): string {
         return this.schoolId ? this.schoolId : this.$store.getters.activeSchoolId
      },
      userIsiUgoAdmin(): boolean {
         return this.$store.getters.userIsiUgoAdmin
      },
   },
   mounted() {
      this.loadFilterOptions()
      this.dataset.setPageSize(25)
      this.dataset.sortColumn = 'FirstName'
      this.dataset.query = [{ name: 'schoolId', value: this.activeSchoolId }]
      this.dataset.filters = [
         { name: 'FirstName', comparison: 'substring', value: '' },
         { name: 'IsEnabled', comparison: 'eq', value: 'true' },
         { name: 'ClassRoomIds', comparison: 'any', value: '', type: 'guid' },
      ]
      this.reload()
   },
   methods: {
      select(row: SchoolTeacherDto) {
         const teacherId = row.Id as string
         this.$router.push({
            name: 'teacher-details',
            params: { schoolId: this.schoolId, teacherId },
         })
      },

      classroomFilterChanged(value: string) {
         this.dataset.updateFilter('ClassRoomIds', value)
         this.dataset.showPage(1)
         this.reload()
      },
      filterTextChanged(value: string) {
         this.dataset.updateFilter('FirstName', value.trim())
         this.dataset.showPage(1)
         this.reload()
      },
      filterInactiveChanged(showInactive: boolean) {
         if (showInactive === true) {
            this.dataset.updateFilter('IsEnabled', '')
         } else {
            this.dataset.updateFilter('IsEnabled', 'true')
         }
         this.dataset.showPage(1)
         this.reload()
      },
      reload() {
         this.dataset.load()
      },

      async loadFilterOptions() {
         // Ensure all is one of the options
         const results = await Api.getClassroomOptions(this.activeSchoolId)
         results.unshift({ name: 'All', value: null })
         this.classroomOptions = results
      },
   },
   components: {
      PageHeader,
      PagedDataTable,
      FilterText,
      FilterDropdown,
      FilterToggle,
      RouteButton,
   },
})
